import { Check } from "@/components/ui/icons";
import { View } from "react-native";

import { cn } from "@/lib/ui/cn";
import { useThemeColors } from "@/theme/theme";

/**
 * The checkbox glyph every bulk-selection surface uses: Print labels, the inventory list's
 * multi-select mode, and a grid cell's checkbox overlay.
 *
 * Checked is a filled box in the brand color; unchecked is an empty outlined box. `overlay` adds an
 * opaque backing for sitting on card art in a grid cell.
 */
export function Checkbox(
  { on, overlay = false }: {
    /** Whether the box is checked. */
    on: boolean;
    /** Adds an opaque backing so the box reads over card art. */
    overlay?: boolean;
  },
) {
  const c = useThemeColors();
  return (
    <View
      className={cn(
        "h-6 w-6 items-center justify-center rounded-md border-2",
        on ? "border-primary bg-primary" : overlay ? "border-border bg-bg/90" : "border-border",
      )}
    >
      {on ? <Check size={15} color={c.primaryForeground} strokeWidth={3} /> : null}
    </View>
  );
}
